<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <div class="error-code">404</div>

        <div class="message">Infelizmente está página não foi encontrada.</div>
    </div>
</div>
